import React, { useState } from 'react';

import LinkIcon from '~/assets/LinkIcon';

import { FaviconTile } from './webSearch.styles';
import { getHostname } from './webSearch.utils';

interface SourceFaviconProps {
  url: string;
  title?: string;
}

const faviconUrl = (url: string): string => {
  const hostname = getHostname(url);
  return hostname ? `https://www.google.com/s2/favicons?domain=${hostname}&sz=32` : '';
};

export const SourceFavicon = ({ url, title }: SourceFaviconProps) => {
  const [error, setError] = useState(false);
  const src = faviconUrl(url);

  return (
    <FaviconTile title={title}>
      {!error && src ? (
        <img src={src} alt={title ?? ''} onError={() => setError(true)} />
      ) : (
        <LinkIcon width={11} height={11} />
      )}
    </FaviconTile>
  );
};
